export class ProductModel {
    id: string = ""
    name: string = ""
    publicKey: string = ""

    constructor(p?:Partial<ProductModel>) {
        Object.assign(this, p)
    }
}
